import RetargetinSegmentsPage from "./RetargetinSegmentsPage";

export default RetargetinSegmentsPage;
